/* eslint-disable import/no-unused-modules */

import React, { ReactElement, useEffect, useState } from 'react'
import {
  Questions as StyledQuestions,
  Question as StyledQuestion,
  QuestionSelect,
} from '../styled-components'
import Select from '../../../../../../input/select'

interface QuizSelectProps {
  correctAnswers: string[]
  answers: string[] | undefined
  onValueChange: (value: string) => void
}
interface SelectType {
  id: number
  label: string
  value: string
}

function QuizSelect({
  correctAnswers,
  onValueChange,
  answers,
}: QuizSelectProps): ReactElement {
  const [value, setValue] = useState<SelectType>()

  useEffect(() => {
    setValue({
      id: 0,
      label: correctAnswers[0],
      value: correctAnswers[0],
    })
  }, [answers, correctAnswers])

  return (
    <StyledQuestions>
      <StyledQuestion>
        <QuestionSelect>
          <Select
            value={value}
            onChange={(selectedItem) => {
              onValueChange(selectedItem.value)
            }}
            options={
              answers?.map((answer, index) => ({
                id: index,
                label: answer,
                value: answer,
              })) as []
            }
          />
        </QuestionSelect>
      </StyledQuestion>
    </StyledQuestions>
  )
}

export default QuizSelect
